import { createEntityAdapter, createSlice, PayloadAction } from "@reduxjs/toolkit";



const animalLoaderDataAdapter = createEntityAdapter({
  selectId: (item: string) => item 
});


export const animalLoaderSlice = createSlice({
  name: "animals",
    initialState: animalLoaderDataAdapter.getInitialState<[]>([]),
      reducers: {
        add: (state, {payload}: PayloadAction<string>) => {
          animalLoaderDataAdapter.addOne(state, payload);
        },
        completed: (state, {payload}) => {
          animalLoaderDataAdapter.removeOne(state,payload);
        }
    }
})


